module.exports = __webpack_public_path__ + "static/img/VN.440e05b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/certified_shipping/VN.png
// module id = NQ7B
// module chunks = 2